<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <ImpInspIndexForm />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ImpInspIndexForm from '@/components/organisms/terminal/form/ImpInspIndexForm'

export default {
  name: 'ImpInspIndexPage',

  components: {
    ImpInspIndexForm,
  },
}
</script>
